module.exports = __webpack_public_path__ + "img/195.8b0cd2d3.jpg";